import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-taxilon-manage-ads',

  templateUrl: './taxilon-manage-ads.component.html',

  styleUrls: ['./taxilon-manage-ads.component.css']

})

export class TaxilonManageAdsComponent implements OnInit {

  lst_City: any = [];

  lst_Ads: any = [];

  lst_Search: any = [];

  lst_Upload: any = [];

  carWork: any = [];

  carType: any = [];

  lst_tiType: any = [];

  bEditMode: boolean = false;

  showFilter: boolean = false;

  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    tiPublishStatus: new FormControl(false),

    bVIP: new FormControl(false),

  });

  mdl_Ads: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strMobile: new FormControl('', Validators.required),

    tiMobileType: new FormControl('', Validators.required),

    strCity: new FormControl('', Validators.required),

    strTitle: new FormControl('', Validators.required),

    tiGPSType: new FormControl('', Validators.required),

    tiType: new FormControl('', Validators.required),

    strYearConstraction: new FormControl(''),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strETime: new FormControl(''),

    strSTime: new FormControl(''),

    strComment: new FormControl(''),

    strColor: new FormControl(''),

    strPassenger: new FormControl(''),

    strVehicleType: new FormControl(''),

    bHourly: new FormControl(''),

    iHourlyRent: new FormControl(''),

    bMonthly: new FormControl(''),

    iMonthlyRent: new FormControl(''),

    bKeyInHand: new FormControl(''),

    iKeyInHandRent: new FormControl(''),

    bVIP: new FormControl(''),

    iTaxilon_Advertisement: new FormControl(''),

    _i: new FormControl(''),

  })

  mdl_Upload: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iTaxilon_Advertisement: new FormControl(''),

    strImage: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    this.getAll_Ads();

    this.getAll_City();

    this.mdl_Search.get('tiPublishStatus')?.valueChanges.subscribe((newValue) => {

      setTimeout(() => {

        this.getAll_Ads();

      }, 10);

    });

    this.mdl_Search.get('bVIP')?.valueChanges.subscribe((newValue) => {

      setTimeout(() => {

        this.getAll_Ads();

      }, 10);

    });

  }

  filter_Result(val: any) {

    this.lst_Ads = this.lst_Search.filter((el: any) => {

      return el.iTaxilon_Advertisement.toString().includes(val.value) ||

        el.strMobile.includes(val.value) ||

        el.strTitle.includes(val.value) ||

        el.strPublishStatus.includes(val.value)

    });

    if (val.value.length == 0) {

      this.lst_Ads = this.lst_Search;

    }

  }

  getAll_Ads = async () => {

    let model = this.mdl_Search.value;

    model.bVIP = model.bVIP == false ? -1 : 1;

    model.tiPublishStatus = model.tiPublishStatus == false ? '-1' : '4';

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Taxilon_Advertisement_ORG_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == -1) return this._tooltip.showError(res.strError);

    this.lst_Ads = res;

    this.lst_Search = res;

  }

  getAll_City = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`TaxiLon_City_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == -1) return this._tooltip.showError(res.strError);

    this.lst_City = res;

    // ------------------------------------------------------

    let res_2 = await axios.post(`GetMobileType`);

    this.carWork = res_2.data;


    // ------------------------------------------------------

    let res_4 = await axios.post(`GetGPSType`);

    this.carType = res_4.data;

    // ------------------------------------------------------

    
    let res_5 = await axios.post(`Taxilon_AdvertisementType_List`);

    this.lst_tiType = JSON.parse(res_5.data);

    console.log(this.lst_tiType)

  }

  new_Ads(bEditMode: boolean = false, item?: any, index?: number) {

    if (bEditMode) {

      this.bEditMode = true;

      this.showFilter = false;

      Object.keys(item).forEach(key => {

        this.mdl_Ads.get(key)?.setValue(item[key])

      })

      this.mdl_Ads.get('_i')?.setValue(index);

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#Ads_Modal").modal('show');

    }

    else {

      this.bEditMode = false;

      this.mdl_Ads.patchValue({

        strMobile: '',

        tiMobileType: '-1',

        strCity: '',

        strTitle: '',

        tiGPSType: '-1',

        strYearConstraction: '',

        strSDate: '',

        strEDate: '',

        strETime: '',

        strSTime: '',

        strComment: '',

        strColor: '',

        strPassenger: '',

        strVehicleType: '',

        tiType: '-1',

        bHourly: false,

        iHourlyRent: 0,

        bMonthly: false,

        iMonthlyRent: 0,

        bKeyInHand: false,

        iKeyInHandRent: 0,

        bVIP: false,

      })

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#Ads_Modal").modal('show');

    }

  }

  submitAds = async () => {

    let model = this.mdl_Ads.value;

    this.mdl_Ads.get('strSTime')?.setValue($("#STime").val());

    this.mdl_Ads.get('strETime')?.setValue($("#ETime").val());

    if (this.mdl_Ads.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!');

    // if (model.bHourly && model.iHourlyRent == 0 || model.iHourlyRent == '' || +model.iHourlyRent < 0) return this._tooltip.showError('نرخ ساعتی را وارد کنید.');

    // if (model.bMonthly && model.iMonthlyRent == 0 || model.iMonthlyRent == '' || +model.iMonthlyRent < 0) return this._tooltip.showError('نرخ ماهیانه را وارد کنید.');

    // if (model.bKeyInHand && model.iKeyInHandRent == 0 || model.iKeyInHandRent == '' || +model.iKeyInHandRent < 0) return this._tooltip.showError('نرخ کلید در اختیار را وارد کنید.');

    if (!this.bEditMode) {

      this._other.Showspinner()

      let res = JSON.parse((await axios.post(`Taxilon_Advertisement_ORG_Save`, this._other.stringNumberToNumber(model))).data.toString());

      this._other.nonespinner();

      if (res.bError || res.iResult == -1 || res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Ads.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ثبت شد');

      $("#Ads_Modal").modal('hide');

    }

    else {

      $.confirm({

        title: `آیا از ویرایش آگهی اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._other.Showspinner()

              let res = JSON.parse((await axios.post(`Taxilon_Advertisement_ORG_Edit`, this._other.stringNumberToNumber(model))).data.toString());

              this._other.nonespinner();

              if (res.bError || res.iResult == -1 || res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Ads[this.mdl_Ads.get('_i')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#Ads_Modal").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  removeAds(item: any, index: number) {

    let model = this._other.stringNumberToNumber({

      ...this.mdl_Search.value,

      iTaxilon_Advertisement: item.iTaxilon_Advertisement

    })

    $.confirm({

      title: `آیا از حذف آگهی اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            const resp = await axios.post('Taxilon_Advertisement_ORG_Delete', model);

            this._other.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this._tooltip.showError(resParse.strError);

            this._tooltip.showSuccess("با موفقیت حذف شد");

            this.lst_Ads.splice(index, 1)

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  openGallery = async (item: any) => {

    let model = this.mdl_Search.value;

    this.mdl_Upload.get('iTaxilon_Advertisement')?.setValue(item.iTaxilon_Advertisement);

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Taxilon_Advertisement_Gallery_List?iTaxilon_Advertisement=${item.iTaxilon_Advertisement}`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    this.lst_Upload = res;

    $("#Gallery_Modal").modal('show');

  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this._tooltip.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.mdl_Upload.controls['strImage'].setValue(base64String.replace('data:image/jpeg;base64,', ''));

        let model = this.mdl_Upload.value;

        this._other.Showspinner()

        let res = JSON.parse((await axios.post(`Taxilon_Advertisement_Gallery_ORG_Save`, this._other.stringNumberToNumber(model))).data.toString());

        this._other.nonespinner();

        this.lst_Upload.push({ ...res[0], strImage: this.mdl_Upload.get('strImage')?.value });

        this._tooltip.showSuccess('تصویر با موفقیت آپلود شد.')


      };

    }

  }

  remove_Thumbnail(item: any, index: number) {

    let model = this._other.stringNumberToNumber({

      ...this.mdl_Search.value,

      iTaxilon_Advertisement_Gallery: item.iTaxilon_Advertisement_Gallery

    })

    $.confirm({

      title: `آیا از حذف این تصویر اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            const resp = await axios.post('Taxilon_Advertisement_Gallery_ORG_Delete', model);

            this._other.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this._tooltip.showError(resParse.strError);

            this._tooltip.showSuccess("با موفقیت حذف شد");

            this.lst_Upload.splice(index, 1)

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'مدیریت آگهی های تاکسی لون.xlsx');
  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._other.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

}
